<template>
    <div>
        <date-picker v-model="checkinDate" input-class="form-control vue-email_screen sd" valueType="format"
            :editable="false" :clearable="false" :disabled-date="disableDateBeforeToday" @change="handleCheckInDate"></date-picker>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
    props: ['stayrestrictions'],
    components: {
        'date-picker': DatePicker
    },
    computed: {
        ...mapGetters(['checkinDate', 'checkoutDate']),
    },
    watch: {
        stayrestrictions: 'updateCheckoutDateLocal',
    },
    methods: {
        ...mapActions(['updateDates', 'updateCheckoutDate']),
        disableDateBeforeToday(date) {
            const today = moment().startOf('day').toDate();
            return date < today;
        },
        handleCheckInDate(date) {
            const minNights = this.getMinNights();
            const checkoutnextDate = moment(date).add(minNights, 'days').format('YYYY-MM-DD');

            // Set check-in date in the store
            this.updateDates({
                checkin_date: date,
                checkout_date: checkoutnextDate
            });

            this.$emit('checkin-date-changed', date);
        },
        getMinNights() {
            // console.log("the stay restrictions is set to, ", this.stayrestrictions);
            let minNights = 1; // default
            if (!this.stayrestrictions || this.stayrestrictions.length == 0) {
                return minNights;
            }

            for (const stayrestriction of this.stayrestrictions) {
                const startdate = moment(stayrestriction.start_date).subtract(1, 'days').format('YYYY-MM-DD');
                const enddate = moment(stayrestriction.end_date).add(1, 'days').format('YYYY-MM-DD');
                if (moment(this.checkinDate).isBetween(startdate, enddate)) {
                    minNights = stayrestriction.minimum_nights;
                    break;
                }
            }
            return minNights;
        },
        updateCheckoutDateLocal() {
            const minNights = this.getMinNights();
            const checkoutnextDate = moment(this.checkinDate).add(minNights, 'days').format('YYYY-MM-DD');
            const diffInDays = moment(this.checkoutDate).diff(moment(this.checkinDate), 'days')

            // console.log(`Checkin date is ${this.checkinDate}`)
            // console.log(`Checkout date is ${this.checkoutDate}`)
            // console.log(`Expected checkout date is ${checkoutnextDate}`)

            // console.log(`Diff in days is ${diffInDays}`)
            // console.log(`Min nights is ${minNights}`)

            if (this.checkinDate && this.checkoutDate < checkoutnextDate) {
                // console.log('next checkout date is updated')
                this.updateDates({
                    checkin_date: this.checkinDate,
                    checkout_date: checkoutnextDate
                });
                this.$emit('checkin-date-changed', this.checkinDate);
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/dates/checkinDate.vue